<template>
  <form class="my-5 mx-5">
    <b-form-group id="nav-client-id" :label="$t($getConst.pages.client.client_name)" label-for="name-input">
      <b-form-input
        id="name-input"
        v-model.trim="$v.client.name.$model"
        :placeholder="$t(this.$getConst.pages.client.enter_client_name)"
        size="lg"
        required
      ></b-form-input>
      <AppFormFeedback :errors="$v.client.name"/>
    </b-form-group>
    <b-form-group id="client" :label="$t($getConst.pages.client.client_scope)" label-for="scope-input">
      <multiselect
        id="scope-input"
        v-model="$v.client.scope.$model"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="scopes"
      >
        <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
      </multiselect>
      <AppFormFeedback :errors="$v.client.scope"/>
    </b-form-group>
  </form>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import {addClient, editClient} from "../../api/clients.api";
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";
  export default {
    name: "ClientForm",
    components: {AppFormFeedback},
    data() {
      return {
        isLoading: false,
        clientExist: false,
        action: 'add',
        client: {
          name: null,
          scope: null,
        },
        isSubmited: false,
        scopes: []
      }
    },
    props: {
      modal_id: null,
      clientToEdit: null,
    },
    validations: {
      client: {
        name: {required},
        scope: {required},
      },
    },
    created() {
      this.scopes = this.$store.getters['auth/allScopes'];
      if (this.clientToEdit) {
        this.action = 'edit';
        this.client=this.clientToEdit;
      }
    },
    mounted() {
      this.$root.$on('isSubmited', submit => {
        this.isSubmited = submit;
      });
    },
    methods: {
      closeModal() {
        this.$bvModal.hide(this.modal_id)
      },
      addClient() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return;
        }
        this.$root.$emit('isLoading', true);
        this.clientExist = false;
        addClient(this.client).then(
          res => {
            this.$root.$emit('onAddClient', res.data);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            if (error.response.data.error.message==="clients_name_unique"){
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.clients_name_unique));
            }else{
              this.handleApiError(error);
            }
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
          }
        )
      },
      editClient() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.isSubmited = false;
          return;
        }
        this.$root.$emit('isLoading', true);
        this.clientExist = false;
        editClient(this.clientToEdit.id,this.client).then(
          res => {
            this.$root.$emit('onEditClient', res.data);
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
            this.closeModal();
          },
          error => {
            if (error.response.status == '422') {
              if (error.response.data.error.message==="clients_name_unique"){
                this.$snotify.error(this.$t(this.$getConst.pages.alerts.clients_name_unique));
              }else {
                this.$snotify.error(this.$t(this.$getConst.pages.alerts.used_client_cant_change_scope));
              }
            }else {
              this.handleApiError(error);
            }
            this.isSubmited = false;
            this.$root.$emit('isLoading', false);
          }
        )
      }
    },
    watch: {
      isSubmited: function() {
        if(this.isSubmited) {
          if (this.clientToEdit) {
            this.editClient();
          } else {
            this.addClient();
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
